import { BooleanInput, Create, CreateContextProvider, Edit, EditContextProvider, Form, required, SaveButton, SelectInput, TextInput, Toolbar, TopToolbar, useCreateController, useEditController, useNotify, useRecordContext, useRedirect, useRefresh, useTranslate } from 'react-admin';
import { Box, Card, Divider, Stack, Typography, Button as MUIButton, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Resources } from '../../resource';
import CategoryForm from './CategoryForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const EditCategory = ({ id, onClose }: { id: string | number; onClose: () => void }) => {
    const notify = useNotify();
    const redirect = useRedirect();
    const t = useTranslate();
    const refresh = useRefresh();

    const controller = useEditController({
        id,
        resource: Resources.categories,
        mutationMode: 'pessimistic',
        mutationOptions: {
            onSuccess: () => {
                notify(t('module.categories.updateSuccess'), { type: 'success' })
                refresh()
                onClose()
            },
            onError: (error: any) => {
                const errorCode = error?.body?.code || error?.code;
                switch (errorCode) {
                    case 'CATEGORY_ALREADY_EXISTS':
                        notify(t('module.categories.validate.conflict'), { type: 'error' });
                        break;
                    default:
                        notify(t('module.categories.unknownErrorUpdate'), { type: 'error' });
                        break;
                }
            },
        },
    });

    if (controller.isLoading || !controller.record) return null;
    
    return (
        <EditContextProvider value={controller}>
            <Form disableInvalidFormNotification>
                <DialogTitle>{t('module.categories.editCategory')}</DialogTitle>
                <DialogContent>
                    <CategoryForm isCreate={false} />
                </DialogContent>
                <DialogActions>
                    <MUIButton
                        variant="outlined"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        {t('actions.cancel')}
                    </MUIButton>
                    <PermissionButton resource="categories" action="update">
                        <SaveButton />
                    </PermissionButton>
                </DialogActions>
            </Form>
        </EditContextProvider>
    );
};

export default EditCategory